import React from 'react';

interface ThinkingIndicatorProps {
  status: string;
}

const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({ status }) => {
  return (
    <div className="message assistant">
      <div className="message-bubble thinking-indicator">
        <span className="thinking-label">{status}</span>
        <span className="thinking-dots">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </span>
      </div>
    </div>
  );
};

export default ThinkingIndicator;
